<template>
    <span>
        <span
            :class="[
                'inline-flex items-center whitespace-nowrap text-yellow-500',
                {
                    'rounded hover:bg-orange-50 transition ease-in-out duration-250 px-1.5 py-0.5': withHoverEffect,
                },
            ]"
        >
            <span v-if="signed && value > 0">+</span>
            <span data-testid="badge-credits-value">{{ formattedValue }}</span>
            <img
                src="/images/icons/icon-badge-credit-full-colored.svg"
                :class="[iconSize, 'ml-1']"
                alt=""
            />
        </span>
    </span>
</template>

<script lang="ts">
import { mapGetters } from 'vuex';

export default {
    name: 'BadgeCredits',
    props: {
        /**
         * will show + in front of the value (if value is bigger than 0)
         */
        signed: {
            type: Boolean,
            default: false,
        },
        /**
         * user credits
         */
        value: {
            type: Number,
            default: 0,
        },
        /**
         * (tailwind) size of badge
         */
        badgeSize: {
            type: Number,
            default: 6,
        },
        /**
         * enable hover effect
         */
        withHoverEffect: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('ui', ['getLocale']),
        formattedValue(): string {
            return this.value.toLocaleString(this.getLocale) as string;
        },
        iconSize() {
            return `w-${this.badgeSize} h-${this.badgeSize}`;
        },
    },
};
</script>
